import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useCoinAPIStore } from '@/stores'
import { Coin, Token } from '@/types'

export const useCoinStore = defineStore('coin', () => {
  const coinAPIStore = useCoinAPIStore()

  const coinList = computed(() => {
    return coinAPIStore.coinList?.map((coin) => {
      return new Coin(coin)
    })
  })

  const tokenList = computed(() => {
    return coinAPIStore.tokenList.map((tokenInfo) => {
      return new Token(tokenInfo)
    })
  })

  return {
    coinList,
    tokenList,
  }
})
